/* istanbul ignore file */

import * as React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
// import { ThemeSettings } from '@europrocurement/flexy-components/src/hooks';
import { setXIdSociete, useSociete } from '@europrocurement/l2d-domain';
import Router from './router/router';
import L2DTheme from './Theme';
import { useAppDispatch } from './redux/types';

const App = function () {
    const routing = useRoutes(Router);
    const theme = L2DTheme();
    const xIdSociete = useSociete();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (xIdSociete !== 12) {
            dispatch(setXIdSociete(12));
        }
    });

    return (
        <ThemeProvider theme={theme}>
            {routing}
            <CssBaseline />
        </ThemeProvider>
    );
};

export default App;
